import { Clock, Sparkles } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";

interface ComingSoonProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
}

const ComingSoon = ({
  title = "Coming Soon",
  description = "This feature is currently under development and will be available soon.",
  icon
}: ComingSoonProps) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-8">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6">
          <div className="text-center">
            <div className="mx-auto w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mb-4">
              {icon || <Clock className="h-8 w-8 text-blue-600" />}
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2 flex items-center justify-center gap-2">
              {title}
              <Sparkles className="h-5 w-5 text-yellow-500" />
            </h2>
            <p className="text-gray-500 mb-6">
              {description}
            </p>
            <div className="flex justify-center gap-1">
              <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
              <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
              <span className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ComingSoon;
